import base from 'wgnet-awesomejs/lib/base';
import { _ } from 'wgnet-awesomejs';
import initializeGeowidgets from 'wgnet-awesomejs/lib/geowidgets';
import mobile from 'wgnet-awesomejs/lib/mobile';

import BaseRegistrationView from 'registration/js/base/registration_view';
import WaitingView from 'registration/js/new/waiting_view';

import NewBasicFormView from 'registration/js/new/form_view';
import ExternalServiceView from 'registration/js/new/external_view';
import template from 'registration/templates/new/wrapper.html';


const RegistrationView = BaseRegistrationView.extend({
    NewBasicFormView,
    ExternalServiceView,
    template
});
const mobileDetect = mobile();

base({ activeElementSelector: 'input:not([readonly=readonly]), .js-validate-ico' });

const CurrentRegistrationView = RegistrationView;

if (_.extract('Settings.Registration.externalSigned')) {
    WaitingView.startWaiting(WaitingView);
}

const registrationView = new CurrentRegistrationView({
    el: '#js-view',
    mobileDetect
});
initializeGeowidgets();
export default registrationView;
